module.exports = __webpack_public_path__ + "4a085dda960759b8bd081478f420de34.MP3";